var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Cookies from "js-cookie";
import _axios from "axios";
export class GKBilling {
    constructor(applicationID, baseUrl = "/", isDashboard = false) {
        this.onRequest = (config) => {
            config.headers["X-GKBApiKey"] = this.applicationID;
            config.headers['X-GKBApplication'] = this.isDashboard ? 'dashboard' : 'store';
            return config;
        };
        this.onResponseSuccess = (response) => __awaiter(this, void 0, void 0, function* () {
            return response;
        });
        this.onResponseFailure = (error) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g;
            const originalRequest = error.config;
            if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 403 &&
                originalRequest.url === "/auth/refresh") {
                yield this.Logout();
                return Promise.reject(error);
            }
            if (((_b = error.response) === null || _b === void 0 ? void 0 : _b.status) === 403 &&
                ((_c = error.response) === null || _c === void 0 ? void 0 : _c.data.error.details) === "signature is invalid") {
                yield this.Logout();
                return Promise.reject(error);
            }
            if (((_d = error.response) === null || _d === void 0 ? void 0 : _d.status) === 403 &&
                !originalRequest._retry &&
                originalRequest.url !== "/auth/refresh" &&
                ((_e = error.response) === null || _e === void 0 ? void 0 : _e.data.error.details) !== "Token is expired") {
                originalRequest._retry = true;
                yield this.RefreshToken();
                return this.axios(originalRequest);
            }
            else if (!originalRequest.url.startsWith("/cards/alias/") &&
                originalRequest.url !== "/auth/signout") {
                if (((_f = error.response) === null || _f === void 0 ? void 0 : _f.status) === 403 || ((_g = error.response) === null || _g === void 0 ? void 0 : _g.status) === 401) {
                    yield this.Logout();
                }
            }
            return Promise.reject(error);
        });
        this.applicationID = applicationID;
        this.isDashboard = isDashboard;
        this.baseUrl = baseUrl + "gks/api";
        this.onRequest = this.onRequest.bind(this);
        this.onResponseSuccess = this.onResponseSuccess.bind(this);
        this.onResponseFailure = this.onResponseFailure.bind(this);
        this.axios = _axios.create();
        this.axios.interceptors.request.use(this.onRequest);
        this.axios.interceptors.response.use(this.onResponseSuccess, this.onResponseFailure);
    }
    Login(email, password, provider) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "post",
                    url: '/auth/signin',
                    withCredentials: false,
                    data: {
                        email,
                        password,
                        provider,
                        application_id: "",
                    },
                });
                if (res.status === 200 && ((_a = res.data) === null || _a === void 0 ? void 0 : _a.data)) {
                    return { token: res.data.data, error: null };
                }
            }
            catch (err) {
                return { token: null, error: (_c = (_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.data) !== null && _c !== void 0 ? _c : err };
            }
            finally {
                const csrfToken = Cookies.get("_csrf");
                this.axios.defaults.headers.post["X-CSRF-Token"] = csrfToken;
            }
        });
    }
    Logout() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "post",
                    url: "/auth/signout",
                    withCredentials: false,
                    data: {},
                });
                if (res.status === 200) {
                    window.dispatchEvent(new CustomEvent("General.Logout", {}));
                }
            }
            catch (err) {
                console.log(err);
            }
            finally {
                const csrfToken = Cookies.get("_csrf");
                this.axios.defaults.headers.post["X-CSRF-Token"] = csrfToken;
            }
        });
    }
    Signup(Email, Password, FirstName, LastName, Country, ZipCode) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "post",
                    url: "/auth/signup",
                    withCredentials: false,
                    data: {
                        Email,
                        Password,
                        FirstName,
                        LastName,
                        Country,
                        ZipCode,
                    },
                });
                if (res.status === 200) {
                    return res;
                }
            }
            catch (err) {
                return { error: (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : err };
            }
            finally {
                const csrfToken = Cookies.get("_csrf");
                this.axios.defaults.headers.post["X-CSRF-Token"] = csrfToken;
            }
        });
    }
    RefreshToken() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "get",
                    url: "/auth/refresh",
                    withCredentials: false,
                });
                if (res.status === 200) {
                    return res.data.data;
                }
            }
            catch (err) {
                console.log(err);
            }
            finally {
                const csrfToken = Cookies.get("_csrf");
                this.axios.defaults.headers.post["X-CSRF-Token"] = csrfToken;
            }
        });
    }
    CompleteSocialLogin(provider, tokenId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "post",
                    url: "/auth/social/complete",
                    withCredentials: false,
                    data: {
                        provider,
                        tokenId,
                    },
                });
                if (res.status === 200 &&
                    res.data.data.access_token &&
                    res.data.data.access_token !== "") {
                    localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("gk-access-token", res.data.data.access_token);
                    return res.data.data;
                }
                else {
                    return res;
                }
            }
            catch (err) {
                return err.response || err;
            }
            finally {
                const csrfToken = Cookies.get("_csrf");
                this.axios.defaults.headers.post["X-CSRF-Token"] = csrfToken;
            }
        });
    }
    ListApiResource({ name, filter }, { pageSize = 10, page = 1, sort, search = "" }) {
        return __awaiter(this, void 0, void 0, function* () {
            let sortFilter = "";
            if (sort) {
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                sortFilter = `&order=${sort}`;
            }
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "get",
                    url: `/${name}?page=${page}&limit=${pageSize}${sortFilter}${filter !== "" ? `&${filter}` : ""}${search !== "" ? `&${search}` : ""}`,
                    withCredentials: false,
                });
                if (res.status === 200) {
                    return res.data.data;
                }
            }
            catch (err) {
                console.log(err);
            }
        });
    }
    GetSectionByName(name) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "get",
                    url: `/sections/name/${name}`,
                    withCredentials: false,
                });
                if (res.status === 200) {
                    return res.data.data;
                }
            }
            catch (err) {
                console.log(err);
            }
        });
    }
    GetApiResource(resource, id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "get",
                    url: `/${resource}/${id}`,
                    withCredentials: false,
                });
                if (res.status === 200) {
                    return res.data.data;
                }
            }
            catch (err) {
                console.log(err);
            }
        });
    }
    DeleteApiResource(resource, id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "delete",
                    url: `/${resource}/${id}`,
                    withCredentials: false,
                });
                if (res.status === 200) {
                    return res.data.data;
                }
            }
            catch (err) {
                console.log(err);
            }
        });
    }
    CreateApiResource({ name, body }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "post",
                    url: `/${name}`,
                    withCredentials: false,
                    data: body,
                });
                if (res.status === 200) {
                    return res.data.data;
                }
            }
            catch (err) {
                console.log(err);
            }
        });
    }
    UpdateApiResource({ name, id, body }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "patch",
                    url: `/${name}/${id}`,
                    withCredentials: false,
                    data: body,
                });
                if (res.status === 200) {
                    return res.data.data;
                }
            }
            catch (err) {
                console.log(err);
            }
        });
    }
    VerifyAccount(code) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "post",
                    url: `/auth/verify`,
                    withCredentials: false,
                    data: {
                        code,
                    },
                });
                return res;
            }
            catch (err) {
                console.log(err);
                return err;
            }
        });
    }
    ReverifyAccount(email) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "patch",
                    url: `/auth/verify`,
                    withCredentials: false,
                    data: {
                        email,
                    },
                });
                return res;
            }
            catch (err) {
                console.log(err);
                return err;
            }
        });
    }
    ResetPassword(email) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "post",
                    url: `/auth/resetpassword`,
                    withCredentials: false,
                    data: {
                        email,
                    },
                });
                return res;
            }
            catch (err) {
                console.log(err);
                return err;
            }
        });
    }
    ChangePassword(code, password) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "post",
                    url: `/auth/changepassword`,
                    withCredentials: false,
                    data: {
                        code,
                        password,
                    },
                });
                return res;
            }
            catch (err) {
                console.log(err);
                return err;
            }
        });
    }
    CreateIntent(cart) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "post",
                    url: `/stripe/intent/create`,
                    withCredentials: false,
                    data: {
                        cart,
                    },
                });
                if (res.status === 200 && res.data.data) {
                    return res.data.data;
                }
                else {
                    return res;
                }
            }
            catch (error) {
                if ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) {
                    return error.response.data;
                }
                return error;
            }
        });
    }
    CreateSetupIntent() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "post",
                    url: `/stripe/intent/setup`,
                    withCredentials: false,
                });
                if (res.status === 200 && res.data.data) {
                    return res.data.data;
                }
            }
            catch (err) {
                console.log(err);
                return err;
            }
        });
    }
    AssignPaymentMethodToSubscription(subscriptionId, paymentMethod) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "post",
                    url: `/subscriptions/${subscriptionId}/paymentMethod`,
                    withCredentials: false,
                    data: {
                        paymentMethod,
                    },
                });
                if (res.status === 200 && res.data) {
                    return res.data;
                }
            }
            catch (err) {
                console.log(err);
                return err;
            }
        });
    }
    ConfirmIntent(id, confirmation) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "post",
                    url: `/stripe/intent/confirm`,
                    withCredentials: false,
                    data: {
                        id,
                        confirmation,
                    },
                });
                if (res.status === 200 && res.data.data) {
                    return res.data.data;
                }
            }
            catch (err) {
                console.log(err);
                return err;
            }
        });
    }
    GetResellerAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "get",
                    url: `/resellers/account`,
                    withCredentials: false,
                });
                if (res.status === 200 && res.data.data) {
                    return res.data.data;
                }
            }
            catch (err) {
                console.log(err);
                return err;
            }
        });
    }
    CreateResellerAccount(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "post",
                    url: `/resellers/account`,
                    withCredentials: false,
                    data: Object.assign({}, params),
                });
                if (res.status === 200 && res.data.data) {
                    return res.data.data;
                }
            }
            catch (err) {
                console.log(err);
                return err;
            }
        });
    }
    TranslateText(text) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "post",
                    url: `/texts/translate`,
                    withCredentials: false,
                    data: { Text: text },
                });
                if (res.status === 200 && res.data.data) {
                    return res.data.data;
                }
            }
            catch (err) {
                console.log(err);
                return err;
            }
        });
    }
    GetResellerLink() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "get",
                    url: `/resellers/link`,
                    withCredentials: false,
                });
                if (res.status === 200 && res.data.data) {
                    return res.data.data;
                }
            }
            catch (err) {
                console.log(err);
                return err;
            }
        });
    }
    GetResellerNet() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "get",
                    url: `/resellers/net`,
                    withCredentials: false,
                });
                if (res.status === 200 && res.data) {
                    return res.data.data.Root;
                }
            }
            catch (err) {
                console.log(err);
                return err;
            }
        });
    }
    GetResellerCounters() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "get",
                    url: `/resellers/counters`,
                    withCredentials: false,
                });
                if (res.status === 200 && res.data) {
                    return res.data.data;
                }
            }
            catch (err) {
                console.log(err);
                return err;
            }
        });
    }
    DownloadInvoice(invoiceId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "get",
                    url: `/invoices/download/${invoiceId}`,
                    withCredentials: false,
                });
                if (res.status === 200 && ((_a = res.data) === null || _a === void 0 ? void 0 : _a.data)) {
                    return {
                        data: res.data.data,
                    };
                }
            }
            catch (err) {
                console.log(err);
                return err;
            }
        });
    }
    UploadDocument(type, file) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const formData = new FormData();
                formData.append("type", type);
                formData.append("name", file.name);
                formData.append("file", file);
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "post",
                    url: `/resellers/upload/`,
                    withCredentials: false,
                    data: formData,
                });
                if (res.status === 201 && ((_a = res.data) === null || _a === void 0 ? void 0 : _a.data)) {
                    return Object.assign({}, res.data.data);
                }
            }
            catch (err) {
                console.log(err);
                return err;
            }
        });
    }
    VerifyToken(token) {
        return __awaiter(this, void 0, void 0, function* () {
            return null;
        });
    }
    GetMyCards(useId, token) {
        return __awaiter(this, void 0, void 0, function* () {
            return null;
        });
    }
    LoadResourceById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.GetApiResource("resources", id);
        });
    }
    GetMyTenant() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "get",
                    url: `/tenants/domain`,
                    withCredentials: false,
                });
                if (res.status === 200 && res.data) {
                    return res.data;
                }
            }
            catch (err) {
                return err;
            }
        });
    }
    GetAliasById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "get",
                    url: `/cards/${id}/alias`,
                    withCredentials: false,
                });
                if (res.status === 200 && res.data) {
                    return res.data;
                }
            }
            catch (err) {
                return err;
            }
        });
    }
    LoadCardById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "get",
                    url: `/cards/${id}`,
                    withCredentials: false,
                });
                if (res.status === 200 && res.data) {
                    return res.data;
                }
            }
            catch (err) {
                return err;
            }
        });
    }
    LoadCardByAlias(alias) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "get",
                    url: `/cards/alias/${alias}`,
                    //withCredentials: false,
                });
                if (res.status === 200 && res.data) {
                    return res.data;
                }
            }
            catch (err) {
                return err;
            }
        });
    }
    LoadSubordinatesByCompanyId(companyId, pageSize = 10, page = 1, searchText = "", sortField = "id", sortDirection = "desc", excel = false) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const responseType = excel ? "blob" : undefined;
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "get",
                    url: `/companies/${companyId}/subordinates?page=${page}&limit=${pageSize}&search=[${searchText},assigned_email]&sort=${sortField}.${sortDirection}`,
                    withCredentials: false,
                    responseType
                });
                if (excel) {
                    return res;
                }
                if (res.status === 200 && res.data) {
                    return res.data;
                }
            }
            catch (err) {
                return err;
            }
        });
    }
    SearchCards(sector, text, pageSize = 10, page = 1) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "get",
                    url: `/search?page=${page}&limit=${pageSize}&sector=${sector}&text=${text}`,
                    withCredentials: false,
                });
                if (res.status === 200 && res.data) {
                    return res.data;
                }
            }
            catch (err) {
                return err;
            }
        });
    }
    AssignCard(card) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "post",
                    url: `/cards/assign`,
                    withCredentials: false,
                    data: {
                        cardId: card.ID,
                        email: card.Assignation.Email,
                        name: card.Assignation.Name
                    }
                });
                if (res.status === 200 && res.data) {
                    return res.data;
                }
            }
            catch (err) {
                return err;
            }
        });
    }
    ClearCard(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "post",
                    url: `/cards/clear`,
                    withCredentials: false,
                    data: {
                        cardId: id,
                    }
                });
                if (res.status === 200 && res.data) {
                    return res.data;
                }
            }
            catch (err) {
                return err;
            }
        });
    }
    GetDashboardUrl(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.axios({
                    baseURL: this.baseUrl,
                    method: "get",
                    url: `/dashboard/link/${id}`,
                    withCredentials: false,
                });
                return res;
            }
            catch (err) {
                console.log(err);
                return err;
            }
        });
    }
    UpdateCard(card) {
        return __awaiter(this, void 0, void 0, function* () {
            return null;
        });
    }
    UploadFiles(file, token, cb) {
        return __awaiter(this, void 0, void 0, function* () {
            return null;
        });
    }
    camelCase2Underscore(s) {
        return s
            .replace(/\.?([A-Z]+)/g, (x, y) => `_${y.toLowerCase()}`)
            .replace(/^_/, "");
    }
}
const isBrowser = new Function("try {return this===window;}catch(e){ return false;}");
